import { getInLifeQuotingFieldsData } from '@in-life/utils/getInLifeQuotingFieldsData';
import { getPersonEntityData } from '@in-life/utils/getPersonEntityData';
import { useEffect } from 'react';

import { Status } from '@generated/gql/graphql';
import { useBasketQuery } from '@hooks/useBasketQuery';
import { useTrackInLifeQuoteLoadedOnce } from '@tracking/trackingEvents';
import { parseValueToPennies } from '@utils/price';

const useInLifeQuoteLoadedTracking = () => {
  const { basketData } = useBasketQuery();
  const basket = basketData?.basket;
  const trackInLifeQuoteLoadedOnce = useTrackInLifeQuoteLoadedOnce();

  useEffect(() => {
    if (basket) {
      const energyTariffChoices = basket.quotes
        .filter((quote) => quote.status.status === Status.Available)
        .flatMap((quote) => {
          if (quote.product.details?.__typename !== 'EnergyProductDetails') {
            return [];
          }
          return [
            {
              name: quote.product.details.quoteType,
              type: quote.product.subtype,
              price: parseValueToPennies(quote.totalMonthlyCost.value),
            },
          ];
        });

      trackInLifeQuoteLoadedOnce(
        {
          energy_tariff_choices: energyTariffChoices,
        },
        {
          contexts: [getInLifeQuotingFieldsData(), getPersonEntityData()],
        }
      );
    }
  }, [basket, trackInLifeQuoteLoadedOnce]);

  return basket;
};

export { useInLifeQuoteLoadedTracking };
